
export const UPDATE_PI_LOADED = 'UPDATE_PI_LOADED';
export const UPDATE_PI_VALIDATION_RESULT = 'UPDATE_PI_VALIDATION_RESULT';
export const UPDATE_PI_ADD_VALIDATION_LISTENER = 'UPDATE_PI_ADD_VALIDATION_LISTENER';
export const UPDATE_PI_REMOVE_VALIDATION_LISTENER = 'UPDATE_PI_REMOVE_VALIDATION_LISTENER';
export const UPDATE_PI_VALIDATE_RESULT = 'UPDATE_PI_VALIDATE_RESULT';

export const updatePiLoaded = (widgetRef) => (dispatch) => {
  dispatch({
    type: UPDATE_PI_LOADED, value: widgetRef
  })
};

export const updatePiValidate = (validationResult) => (dispatch) => {
  dispatch({
    type: UPDATE_PI_VALIDATION_RESULT, value: validationResult
  })
};

export const updatePiAddValidationListener = () => (dispatch) => {
  dispatch({
    type: UPDATE_PI_ADD_VALIDATION_LISTENER
  })
};

export const updatePiRemoveValidationListener = () => (dispatch) => {
  dispatch({
    type: UPDATE_PI_REMOVE_VALIDATION_LISTENER
  })
};

export const updatePiValidateResult = (validateResult) => (dispatch) => {
  dispatch({
    type: UPDATE_PI_VALIDATE_RESULT, value: validateResult
  })
}



// WEBPACK FOOTER //
// ./src/update-pi/UpdatePiActions.js